import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { NoRightClickDirective } from './directives/no-right-click.directive';
import { HideMissingDirective } from './directives/handle-missing-img';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    HttpModule,
  ],
  declarations: [
    NoRightClickDirective,
    HideMissingDirective,
  ],
  exports: [ NoRightClickDirective, HideMissingDirective ],
  entryComponents: []
})
export class SharedModule {}
